import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import PageSignUp from '@pages/signup/ui/PageSignUp';

export const Route = createFileRoute('/_guest/signup')({
  component: PageSignUp,
});
